module.exports = __webpack_public_path__ + "static/media/product2.a5ec1939.jpg";